<script>
  import { Link } from "svelte-routing";
  import { menu_items_global, menu_items_auth, user_store, site_activate_store, page_setting_store } from '../stores.js';
  import breakpoints from "../utils/breakpoints";
  const bp = breakpoints();
  import Button from '@smui/button/styled';
  import { fade, fly } from 'svelte/transition';
  import { onMount } from "svelte";


  $: is_mobile = $bp === "sm";

  let myself = {};
  let is_site_activated = false;
  let show_mobile_menu = false;
  let menu_items = [];
  let selected_menu = '';
  let config_landing_page_menu = [];

  user_store.subscribe(value => {
    myself = value;
    if (myself.is_authenticated) {
      menu_items = menu_items_auth; //.filter(item => item[0] !== 'My Profile');
    }
    else { menu_items = menu_items_global; }
  });
  site_activate_store.subscribe(value => {
    is_site_activated = value;
  });
  page_setting_store.subscribe(page_setting => {

    config_landing_page_menu = Object.keys(page_setting.landing_page_menu).filter(key => page_setting.landing_page_menu[key]);

    console.log('config_landing_page_menu', config_landing_page_menu);
    if (!myself.is_authenticated) {
      menu_items = menu_items.filter(item => config_landing_page_menu.includes(item[0]));
    }
  });

  onMount(() => {
    selected_menu = window.location.pathname;
  });

  function toggleMenu() {
    show_mobile_menu = !show_mobile_menu;
  }

  const header_check = (tab_title) => {
    if (tab_title === 'Referrals' && (myself.user && myself.user.role !== 'client')) {
      return false;
    }
    if (tab_title === 'Book a Service' && (myself.user && myself.user.role !== 'client')) {
      return false;
    }
    return true;
  }
</script>

{#if !is_site_activated}
<div class="activatedbar">
  <div class="material-icons-outlined">info</div> <div>Website inactive</div>
</div>
{/if}

<div class="headerbar">
  <div class="buttonholder">
    {#if is_mobile}
      <div class="material-icons mobilemenu" on:click|preventDefault|stopPropagation={toggleMenu}>menu</div>
      {#if show_mobile_menu}
      <div transition:fade class="overlay" on:click|preventDefault|stopPropagation={toggleMenu}></div>
      <div transition:fly="{{ x: 200, duration: 500 }}" class="sidemenu" show_mobile_menu>
        {#each menu_items as header_menu}
          {#if header_check(header_menu[0]) && header_menu[0] !== 'Home'}
            <Link to={header_menu[1]} style={`padding: 7px 15px;cursor: pointer;color: #00b300 !important;font-size: 18px;font-weight: ${selected_menu === header_menu[1] ? 700 : 400}`}>
              {(myself.user && myself.user.role === 'client' && header_menu[0] === 'Jobs') ? 'Services' : header_menu[0]}
            </Link>
          {:else}
            <a href='/' target='_blank' style='padding: 7px 15px;cursor: pointer;color: #00b300 !important;font-size: 18px;font-weight: 400'>Home</a>
          {/if}
        {/each}
      </div>
      {/if}
    {:else}
      {#each menu_items as header_menu}
      {#if header_check(header_menu[0])}
        <div class="menubutton">
          {#if header_menu[0] !== 'Home'}
            <Link to={header_menu[1]} style={`cursor: pointer;color: green !important;font-size: 18px;font-weight: ${selected_menu === header_menu[1] ? 700 : 400}`}>
              {(myself.user && myself.user.role === 'client' && header_menu[0] === 'Jobs') ? 'Services' : header_menu[0]}
            </Link>
          {:else}
            <a href='/' target='_blank' style='cursor: pointer;color: green !important;font-size: 18px;font-weight: 400'>Home</a>
          {/if}
        </div>
      {/if}
      {/each}
    {/if}
  </div>
</div>

<style>
  .activatedbar {
      color: white;
      background-color: #f44336;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      font-size: 14px;
  }
  .activatedbar .material-icons-outlined {
      margin-right: 20px;
  }
  .headerbar {
      width: 100%;
      height: 110px;
      background-color: white;
      /* color: white; */
      color: rgba(0, 0, 0, 0.87);
      margin: 0 0 0 0 !important;
      position: -webkit-sticky; /* Safari */
      position: sticky;
      top: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 999;
  }

  .buttonholder {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: center;
  }
  .buttonholder > .menubutton{
    padding-right: 25px;
  }
  :global(a.active) {
    font-weight: bold;
  }


  @media (max-device-width: 1024px), (max-width: 1023px) { 
    .headerbar {
      height: 68px;
    }

    .mobilemenu {
      cursor: pointer;
    }
    .overlay {
      position:fixed;
      padding:0;
      margin:0;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      background:rgba(0,0,0,0.75);
      z-index: 0;
    }
    .sidemenu {
      position:fixed;
      margin:0;
      padding-top: 50px;
      top:0;
      right:0;
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: flex-start;
      z-index: 0;
      background-color: white;
    }
  }
</style>
